import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconSearch = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M24.992 1.894c-3.331.337-4.99.713-7.518 1.707C11.41 5.983 6.573 10.66 3.89 16.733c-1.641 3.715-2.333 8.337-1.874 12.53.631 5.778 3.492 11.453 7.732 15.339 3.756 3.443 8.198 5.576 13.131 6.308 5.412.802 10.607-.12 15.488-2.746 1.223-.659 2.674-1.64 3.954-2.672l.178-.144 8.206 8.197c4.513 4.508 8.307 8.256 8.43 8.328.362.213.937.298 1.383.206 1.351-.28 2.034-1.858 1.301-3.007-.1-.158-3.842-3.946-8.314-8.416s-8.13-8.15-8.13-8.178.183-.273.406-.544c.851-1.038 1.921-2.673 2.646-4.046 2.453-4.648 3.335-10.44 2.39-15.692-.941-5.228-3.663-10.22-7.475-13.71-4.122-3.774-8.91-5.928-14.447-6.502-.674-.07-3.467-.134-3.904-.09m0 4.035-.864.092c-2.93.31-6.202 1.49-8.823 3.18-4.068 2.624-7.182 6.78-8.547 11.407-1.512 5.123-1.049 10.396 1.331 15.168 1.527 3.06 3.628 5.516 6.476 7.568 3.635 2.618 7.964 3.926 12.597 3.805 3.133-.082 5.849-.778 8.742-2.24 2.053-1.037 3.62-2.178 5.256-3.826 3.024-3.047 5.038-6.946 5.72-11.069.73-4.42.109-8.628-1.866-12.651-1.025-2.09-2.225-3.762-3.894-5.427-3.947-3.939-9.17-6.076-14.752-6.037-.651.004-1.27.018-1.376.03" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconSearch.displayName = 'IconSearch';